import { ERRORS } from '../constants'

export const showError = (message, prefixed = false) => {
  // eslint-disable-next-line no-alert
  alert(`${prefixed ? ERRORS.base : ''}${message}`)
}

export const showReloadError = (message = null, prefixed = false) => {
  // eslint-disable-next-line no-alert
  if (window.confirm(`${prefixed ? ERRORS.base : ''}${message ?? ERRORS.baseExtended}`)) {
    window.location.reload()
  }
}

export const validatePhone = input => input.length === 11

export const validateCode = input => input.length === 4

export const getWsUri = ({ uuid }) => `wss://${window.MEDTOCHKA_DOMAIN}/ws/phone_confirmation/call/${uuid}?subscribe-broadcast`
